import Account from './wallet/Account'
import Allowlist from './wallet/Allowlist'
import Challenge from './wallet/Challenge'
import Connection from './wallet/Connection'
import Limit from './wallet/Limit'
import { TaskManagerWallet } from './wallet/TaskManager'
import Token from './wallet/Token'
import Transaction from './wallet/Transaction'
import MultisigWallet from './wallet/Wallet'
import WalletUtils from './wallet/Utils'
import Notification from './wallet/Notification'
import Onboarding from './wallet/Onboarding'
import Rates from './wallet/Rates'
import Policy from './wallet/Policy'
import Config from '../config'
import { IConnection } from '@iamo/custody-lib/build/shared/Connection'
export class Wallet {

    account: Account
    allowList: Allowlist
    challenge: Challenge
    connection: Connection
    limit: Limit
    notification: Notification
    onboarding: Onboarding
    policy: Policy
    rates: Rates
    taskManager: TaskManagerWallet
    token: Token
    transaction: Transaction
    utils: WalletUtils
    wallet: MultisigWallet

    constructor(config: Config){
        this.connection = new Connection()

        

        let nameProfile
        if(config && config.custodyLibBlockchainProfile){
            nameProfile = config.custodyLibBlockchainProfile.name
        }
        else {
            nameProfile = "localDevChain"
        }
        const con = this.connection.createConnection(nameProfile)

        this.setConnection(con)

    }

    setConnection(connection: IConnection){
        this.account = new Account(connection)
        this.allowList = new Allowlist(connection)
        this.challenge = new Challenge(connection)
        this.limit = new Limit(connection)
        this.notification = new Notification(connection)
        this.onboarding = new Onboarding(connection)
        this.policy = new Policy(connection)
        this.rates = new Rates(connection)
        this.taskManager = new TaskManagerWallet(connection)
        this.token = new Token(connection)
        this.transaction = new Transaction(connection)
        this.utils = new WalletUtils(connection)
        this.wallet = new MultisigWallet(connection)

    }
}

export default Wallet
